import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class DropdownItem extends PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    renderAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.node,
    className: PropTypes.string,
    prefix: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    value: null,
    title: null,
    active: false,
    disabled: false,
    prefix: null,
    onClick: undefined,
    renderAs: 'a',
    children: null,
    className: null,
  };

  static isDropDownItem = true;

  onClick = () => {
    const { onClick, value, disabled } = this.props;
    if (onClick && !disabled) {
      onClick(value);
    }
  };

  render() {
    const {
      value,
      filterValue,
      title,
      onClick,
      prefix,
      active,
      disabled,
      children,
      renderAs,
      className,
      ...props
    } = this.props;

    const Element = renderAs;

    return (
      <Element
        title={title || value}
        {...props}
        onClick={this.onClick}
        role="presentation"
        className={classnames('dropdown-item', className, {
          'is-active': active,
          'is-disabled': disabled,
        })}
      >
        {prefix}
        {children}
      </Element>
    );
  }
}
